module.exports = __webpack_public_path__ + "static/media/leader.14fed6f2.gif";